import {
  FixedLeaveTypeId,
  UNKNOWN_LEAVE_TYPE_LABEL,
  UNKNOWN_LEAVE_TYPE_SURFACE_COLOR,
  UNKNOWN_LEAVE_TYPE_WRAPPER_COLOR
} from '@/services/availability/availability.types';
import { useLeaveType } from '@/services/leaveManagement/LeaveTypesProvider';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { cellStyling } from './teamMemberCalendar.const';

type LeaveTypeDisplay = {
  hasLeaveType: boolean;
  wrapperColor?: string;
  label?: string;
  colour?: string;
  badge?: ReactNode;
  card?: ReactNode;
};

export const useLeaveTypeCalendarDisplay = (leaveTypeId?: string): LeaveTypeDisplay => {
  const leaveLookup = useLeaveType(leaveTypeId);

  const unknownLeaveType = leaveTypeId === FixedLeaveTypeId.UNKNOWN;

  if (!leaveLookup && !unknownLeaveType) {
    return {
      hasLeaveType: false
    };
  }

  const colour = unknownLeaveType ? UNKNOWN_LEAVE_TYPE_SURFACE_COLOR : leaveLookup?.properties.color;

  const wrapperColor = unknownLeaveType ? UNKNOWN_LEAVE_TYPE_WRAPPER_COLOR : `${colour}80`;

  const label = unknownLeaveType ? UNKNOWN_LEAVE_TYPE_LABEL : leaveLookup?.properties.displayName;

  const sharedClasses = unknownLeaveType ? 'border border-gray-300 bg-gray-200 text-gray-700' : '';

  return {
    hasLeaveType: true,
    colour,
    wrapperColor,
    label,
    badge: (
      <div className={twMerge('px-2 py-1 text-xs rounded-md', sharedClasses)} style={{ backgroundColor: colour }}>
        {label}
      </div>
    ),

    card: (
      <div className={twMerge(cellStyling, sharedClasses)} style={{ backgroundColor: colour }}>
        {label}
      </div>
    )
  };
};
